/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

import com.garmin.fit.types.*
import kotlin.time.Instant

/**
 * The FIT `course` message.
 *
 * A thin typed view over [Mesg]: the accessors below read and write the same
 * numbered fields the untyped API exposes, so nothing is hidden by using them.
 */
public open class CourseMesg : Mesg {
    public constructor() : super("Course", Profile.MesgNum.COURSE)

    public constructor(mesg: Mesg) : super(mesg)

    internal constructor(mesg: Mesg, adopt: Boolean) : super(mesg, adopt)

    /** sport. */
    public var sport: Sport?
        get() = (getFieldValue(SPORT_FIELD_NUM) as? UByte)?.let { Sport.fromValue(it) }
        set(value) = setFieldValue(SPORT_FIELD_NUM, value?.value)

    /** name. */
    public var name: String?
        get() = getFieldValue(NAME_FIELD_NUM) as? String
        set(value) = setFieldValue(NAME_FIELD_NUM, value)

    /** capabilities. */
    public var capabilities: CourseCapabilities?
        get() = (getFieldValue(CAPABILITIES_FIELD_NUM) as? UInt)?.let { CourseCapabilities.fromValue(it) }
        set(value) = setFieldValue(CAPABILITIES_FIELD_NUM, value?.value)

    /** sub_sport. */
    public var subSport: SubSport?
        get() = (getFieldValue(SUB_SPORT_FIELD_NUM) as? UByte)?.let { SubSport.fromValue(it) }
        set(value) = setFieldValue(SUB_SPORT_FIELD_NUM, value?.value)

    public companion object {
        public const val SPORT_FIELD_NUM: UByte = 4u
        public const val NAME_FIELD_NUM: UByte = 5u
        public const val CAPABILITIES_FIELD_NUM: UByte = 6u
        public const val SUB_SPORT_FIELD_NUM: UByte = 7u

        /**
         * The profile definition of every field of this message, with no values.
         *
         * Built once when this class is first touched, and handed out only as
         * copies, so the decoder pays for a message type it never meets nothing.
         */
        internal val PROTOTYPE_FIELDS: Map<Int, Field> = buildPrototypeFields()

        private fun buildPrototypeFields(): Map<Int, Field> {
            val fields = LinkedHashMap<Int, Field>()
            fields[4] = Field("Sport", 4u, BaseType.ENUM, 1.0, 0.0, "", false)
            fields[5] = Field("Name", 5u, BaseType.STRING, 1.0, 0.0, "", false)
            fields[6] = Field("Capabilities", 6u, BaseType.UINT32Z, 1.0, 0.0, "", false)
            fields[7] = Field("SubSport", 7u, BaseType.ENUM, 1.0, 0.0, "", false)
            return fields
        }
    }
}
